import { useState } from 'react';

const faqs = [
  {
    q: '51影院是否需要注册或付费？',
    a: '完全不需要。51影院是一个免费高清影视聚合平台，整合奇优影院、98影院、优优色影院、cc影院、96影院等多站资源，所有内容均可免费在线观看，无需注册、无需付费、无需下载任何插件。',
  },
  {
    q: '影片画质如何？支持哪些清晰度？',
    a: '我们提供从标清到4K超清的多档清晰度选择，覆盖720P、1080P、2K和4K。配合服务器全面升级，播放流畅不卡顿，适配各类网络环境，手机端和电脑端均可畅享高清观影体验。',
  },
  {
    q: '更新频率是怎样的？新片多久能上线？',
    a: '51影院坚持每日更新，通常在影片正式上线或热播剧更新后数小时内同步刷新片源。cc影院和96影院的最新内容第一时间同步，确保您不错过任何精彩。',
  },
  {
    q: '支持哪些设备观看？手机能看吗？',
    a: '全设备兼容。无论是电脑、平板还是手机，打开浏览器即可直接观看，无需安装APP。页面针对移动端做了全面适配，在小屏幕上也有出色的观影体验。',
  },
  {
    q: '影片种类齐全吗？有分类筛选功能吗？',
    a: '目前覆盖电影、电视剧、综艺、动漫、纪录片五大品类，下设科幻、悬疑、喜剧、古装、韩剧、日漫等20余个子分类。通过热门话题和专题合集可以快速定位您感兴趣的内容。',
  },
  {
    q: '为什么整合多个站点而不是自建片源？',
    a: '聚合模式让我们能够同时对接奇优影院、98影院、优优色影院、cc影院、96影院等多个站点的资源优势，片源覆盖更广、更新速度更快、资源冗余更好，单一站点无法比拟。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">常见问答</h2>
          <p className="text-sm text-foreground-500">你可能想了解的问题都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border-b border-background-200/40 last:border-b-0"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between py-4 text-left"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-200 pr-4">
                  {faq.q}
                </h3>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                  {openIndex === i ? (
                    <i className="ri-arrow-up-s-line text-foreground-400"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line text-foreground-400"></i>
                  )}
                </div>
              </button>
              {openIndex === i && (
                <div className="pb-4 animate-fade-in">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}